export const styles = {
    clickIcon: { cursor: 'pointer', fontSize: '150%', position: 'relative', verticalAlign: 'middle' },
    disabledClickIcon: { fontSize: '150%', position: 'relative', verticalAlign: 'middle' }
};
